angular
  .module 'gym.components'
  .directive 'noPaymentSystem', ->
    restrict: 'EA'
    template: require('templates/components/contacts/wallet/no_payment_system.html.slim')
